const linuxNativeScripts = [
  {
    id: "812efb48-452a-481e-add2-765f0eb1426c",
    name: "editors.policy.actions.Reboot",
    categoryId: 3,
  },
  {
    id: "233d7933-d594-4199-8bd2-d3f65a176ca4",
    name: "editors.policy.actions.sshEnable",
    categoryId: 3,
  },
  {
    id: "8c8271b1-0f62-4924-93ca-0413857359b6",
    name: "editors.policy.actions.sshDisable",
    categoryId: 3,
  },
  {
    id: "4bd4330a-260f-43e9-9709-ed28e8be767f",
    name: "editors.policy.actions.FirewallDisable",
    categoryId: 3,
  },
  {
    id: "9D5007BF-D40A-4918-9B11-E80C5DD08F1D",
    name: "editors.policy.actions.FirewallEnable",
    categoryId: 3,
  },
  {
    id: "13e5be81-147c-4236-a7cc-bb8b512f4ab5",
    name: "editors.policy.actions.emptyTrash",
    categoryId: 3,
  },
  {
    id: "2f8b6cc5-d81c-4754-9d15-088050064215",
    name: "editors.policy.actions.sleepDisable",
    categoryId: 3,
  },
  {
    id: "b0db58e4-5eef-4ab8-ba64-96bd00df2a35",
    name: "editors.policy.actions.sleepEnable",
    categoryId: 3,
  },
  {
    id: "b1db58e4-6eef-4ab8-ba64-96bd00df2a35",
    name: "editors.policy.actions.forceLogout",
    categoryId: 3,
  },
  {
    id: "85c0859c-a7ba-4624-8909-8cecca1059fb",
    name: "editors.policy.actions.FlushDNS",
    categoryId: 3,
  },
  {
    id: "6cbdfa90-65ce-4b1b-81b4-3554c77cd96b",
    name: "editors.policy.actions.listAvailablePatches",
    categoryId: -2,
  },
  {
    id: "a4692700-565d-4767-8f65-2fc38b507159",
    name: "editors.policy.actions.installAllAvailable",
    categoryId: -2,
  },
  {
    id: "8578528f-d82c-49d7-aca5-fb14ad293478",
    name: "editors.policy.actions.installAllAvailableRestartLinux",
    categoryId: -2,
  },
  {
    id: "b8ad0990-8dcb-4db2-aea8-622577154e49",
    name: "editors.policy.actions.listSecurityPatches",
    categoryId: -2,
  },
  {
    id: "d1a0d037-700e-4c27-8120-5d604acdb350",
    name: "editors.policy.actions.installSecurityPatches",
    categoryId: -2,
  },
  {
    id: "38e27612-8af6-4799-bdae-daa24176e66d",
    name: "editors.policy.actions.installSecurityPatchesRestart",
    categoryId: -2,
  },
]

export default linuxNativeScripts
